export const RECOMMENDATION_LIBRARY = [
    {
        id: 'rec-sna-application',
        title: 'Vraag het SNA-keurmerk aan',
        description: 'Het SNA-keurmerk (NEN 4400-1) wordt onder WTTA verplicht voor uitleners. Start direct met de aanvraag, de doorlooptijd is doorgaans 4 tot 8 maanden inclusief audit.',
        priority: 'critical',
        category: 'certificering',
        estimatedEffortDays: 20,
        estimatedCostMin: 2500,
        estimatedCostMax: 5000,
        appliesWhen: {
            companyType: 'uitlener',
            triggerQuestionId: 'sna_status',
            triggerAnswerValues: ['none', 'expired'],
        },
    },
    {
        id: 'rec-sna-renewal',
        title: 'Maak de SNA-aanvraag af',
        description: 'Je bent al in aanvraag voor het SNA-keurmerk. Zorg dat de openstaande punten uit de pre-audit binnen 60 dagen zijn afgehandeld zodat het certificaat tijdig wordt afgegeven.',
        priority: 'high',
        category: 'certificering',
        estimatedEffortDays: 8,
        estimatedCostMin: 1000,
        estimatedCostMax: 2500,
        appliesWhen: {
            companyType: 'uitlener',
            triggerQuestionId: 'sna_status',
            triggerAnswerValues: ['pending'],
        },
    },
    {
        id: 'rec-cao-implementation',
        title: 'Implementeer geverifieerde CAO-toepassing',
        description: 'Onder WTTA moet de inlenersbeloning aantoonbaar correct worden toegepast. Richt een proces in om bij elke nieuwe inlener de geldende CAO op te vragen, vast te leggen en jaarlijks te verifiëren.',
        priority: 'critical',
        category: 'compliance',
        estimatedEffortDays: 15,
        estimatedCostMin: 3000,
        estimatedCostMax: 8000,
        appliesWhen: {
            companyType: 'uitlener',
            triggerQuestionId: 'cao_compliance',
            triggerAnswerValues: ['partial', 'unclear'],
        },
    },
    {
        id: 'rec-cao-verification',
        title: 'Verifieer de CAO-toepassing per inlener',
        description: 'Je past CAO toe op basis van aanname. Voer een audit uit op jouw lopende inleen-relaties en stel waar nodig de loonopbouw bij voordat WTTA in werking treedt.',
        priority: 'high',
        category: 'compliance',
        estimatedEffortDays: 7,
        estimatedCostMin: 1500,
        estimatedCostMax: 4000,
        appliesWhen: {
            companyType: 'uitlener',
            triggerQuestionId: 'cao_compliance',
            triggerAnswerValues: ['assumed'],
        },
    },
    {
        id: 'rec-tax-issues-cleanup',
        title: 'Los openstaande belasting- en premie-issues op',
        description: 'Substantiële naheffingen of boetes blokkeren vrijstelling van de waarborgsom. Stel met jouw fiscaal adviseur een plan op om openstaande punten af te handelen en compliance aan te tonen.',
        priority: 'critical',
        category: 'financieel',
        estimatedEffortDays: 12,
        estimatedCostMin: 4000,
        estimatedCostMax: 15000,
        appliesWhen: {
            companyType: 'uitlener',
            triggerQuestionId: 'tax_history',
            triggerAnswerValues: ['issues'],
        },
    },
    {
        id: 'rec-deposit-financing',
        title: 'Regel de financiering van de waarborgsom',
        description: 'De waarborgsom van € 100.000 is voor jouw organisatie alleen haalbaar met externe financiering. Vraag tijdig offertes op bij jouw bank voor een bankgarantie of werk aan een vrijstelling via 4 jaar schone historie + SNA.',
        priority: 'high',
        category: 'financieel',
        estimatedEffortDays: 5,
        estimatedCostMin: 2000,
        estimatedCostMax: 6000,
        appliesWhen: {
            companyType: 'uitlener',
            triggerQuestionId: 'waarborgsom_capacity',
            triggerAnswerValues: ['financing'],
        },
    },
    {
        id: 'rec-action-plan',
        title: 'Stel een concreet WTTA-actieplan op',
        description: 'Zonder actieplan met deadlines en eigenaren ontbreekt sturing. Definieer in 2 weken een plan met de top-10 maatregelen, een eigenaar per maatregel en een einddatum vóór de WTTA-ingangsdatum.',
        priority: 'high',
        category: 'planning',
        estimatedEffortDays: 4,
        estimatedCostMin: 0,
        estimatedCostMax: 4000,
        appliesWhen: {
            companyType: 'uitlener',
            triggerQuestionId: 'action_plan_status',
            triggerAnswerValues: ['none', 'progress'],
        },
    },
    {
        id: 'rec-migrant-housing',
        title: 'Borg huisvesting van arbeidsmigranten',
        description: 'Met meer dan 25% arbeidsmigranten is huisvestingscompliance een verhoogd risico. Controleer of je SNF-gecertificeerde huisvesting gebruikt of zelf certificering nodig hebt.',
        priority: 'high',
        category: 'compliance',
        estimatedEffortDays: 10,
        estimatedCostMin: 1500,
        estimatedCostMax: 5000,
        appliesWhen: {
            companyType: 'uitlener',
            triggerQuestionId: 'labor_migrants_percentage',
            triggerAnswerValues: ['high'],
        },
    },
    {
        id: 'rec-sna-supplier-check',
        title: 'Implementeer SNA-verificatie van jouw uitleners',
        description: 'Als inlener ben je onder WTTA medeverantwoordelijk. Richt een procedure in waarbij je bij aanvang en periodiek (minimaal halfjaarlijks) controleert of jouw uitleners SNA-gecertificeerd zijn.',
        priority: 'critical',
        category: 'compliance',
        estimatedEffortDays: 6,
        estimatedCostMin: 1000,
        estimatedCostMax: 4000,
        appliesWhen: {
            companyType: 'inlener',
            triggerQuestionId: 'sna_verification',
            triggerAnswerValues: ['sometimes', 'never'],
        },
    },
    {
        id: 'rec-contract-clauses',
        title: 'Voeg WTTA-clausules toe aan jouw inhuurcontracten',
        description: 'Contractuele borging van WTTA-vereisten is jouw belangrijkste risicobeperking. Laat jouw juridisch adviseur een addendum opstellen en rol dit uit op alle bestaande en nieuwe contracten.',
        priority: 'high',
        category: 'compliance',
        estimatedEffortDays: 8,
        estimatedCostMin: 2000,
        estimatedCostMax: 6000,
        appliesWhen: {
            companyType: 'inlener',
            triggerQuestionId: 'contract_wtta_clauses',
            triggerAnswerValues: ['no', 'partial', 'unknown'],
        },
    },
    {
        id: 'rec-g-account',
        title: 'Maak G-rekening verplicht voor leveranciers',
        description: 'Een G-rekening beperkt jouw aansprakelijkheid voor niet-afgedragen loonheffingen. Maak het storten van het loondeel op een G-rekening verplicht in al jouw contracten.',
        priority: 'high',
        category: 'compliance',
        estimatedEffortDays: 5,
        estimatedCostMin: 500,
        estimatedCostMax: 2500,
        appliesWhen: {
            companyType: 'inlener',
            triggerQuestionId: 'g_account_process',
            triggerAnswerValues: ['no', 'partial'],
        },
    },
    {
        id: 'rec-supplier-consolidation',
        title: 'Consolideer jouw leveranciersbestand',
        description: 'Met meer dan 10 verschillende uitleners groeit jouw compliance-risico exponentieel. Inventariseer welke leveranciers strategisch zijn en bouw richting een kortere lijst van WTTA-compliant partners.',
        priority: 'medium',
        category: 'profiel',
        estimatedEffortDays: 6,
        estimatedCostMin: 1500,
        estimatedCostMax: 5000,
        appliesWhen: {
            companyType: 'inlener',
            triggerQuestionId: 'supplier_count',
            triggerAnswerValues: ['many'],
        },
    },
    {
        id: 'rec-inlener-action-plan',
        title: 'Stel een leveranciers-toetsingsplan op',
        description: 'Zonder concreet plan om jouw uitleners te toetsen op WTTA-compliance loop je onnodig keten-aansprakelijkheid op. Definieer een toetsings-cadans en koppel een eigenaar aan elke leverancier.',
        priority: 'high',
        category: 'planning',
        estimatedEffortDays: 4,
        estimatedCostMin: 0,
        estimatedCostMax: 3500,
        appliesWhen: {
            companyType: 'inlener',
            triggerQuestionId: 'inlener_action_plan',
            triggerAnswerValues: ['no', 'considering'],
        },
    },
];
export function generateRecommendations(companyType, answers) {
    const matched = [];
    for (const rec of RECOMMENDATION_LIBRARY) {
        const { companyType: requiredType, triggerQuestionId, triggerAnswerValues } = rec.appliesWhen;
        if (requiredType && requiredType !== 'both' && requiredType !== companyType) {
            continue;
        }
        const givenAnswer = answers[triggerQuestionId];
        if (!givenAnswer)
            continue;
        if (triggerAnswerValues.includes(givenAnswer)) {
            matched.push(rec);
        }
    }
    return matched.sort(byPriorityThenEffort);
}
const PRIORITY_ORDER = {
    critical: 0,
    high: 1,
    medium: 2,
    low: 3,
};
function byPriorityThenEffort(a, b) {
    const priorityDiff = PRIORITY_ORDER[a.priority] - PRIORITY_ORDER[b.priority];
    if (priorityDiff !== 0)
        return priorityDiff;
    return b.estimatedEffortDays - a.estimatedEffortDays;
}
//# sourceMappingURL=recommendations.js.map